export class VideoModel {
    id: string | undefined;
    category: string | undefined;
    autoPurge: number | undefined;
    stationId: string | undefined;
    via: string = "";
    codeDescription: string = "";
    type: string = "";
    code: string = "";
    fileName: string | undefined;
}